<template>
  <div id="scroll-target">
    <vs-row class="mb-2">
      <vs-col vs-type="flex" vs-lg="7" vs-sm="12" class="m-0 p-0"> </vs-col>
      <vs-col vs-align="flex-end" vs-lg="5" vs-sm="12" class="m-0 p-0">
        <div class="text-right hidden lg:inline-block" style="float: right">
          <ul class="demo-alignment pb-0" style="float: right">
            <li class="pl-4 border-0 border-solid border-grey">
              <i
                class="fas fa-file-download fa-2x cursor-pointer hover:text-primary"
                @click="onExport()"
              ></i>
            </li>
          </ul>
        </div>
      </vs-col>
    </vs-row>
    <vs-card>
      <b-table
        ref="table"
        style="min-height: 600px;"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="true"
        :select-mode="`multi`"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="columns"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :foot-clone="true"
        no-footer-sorting
        :no-provider-sorting="true"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height:600px;">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>

        <template v-slot:cell(progress)="data">
          <div style="width:150px;">
            <vs-progress :height="12" :percent="(data.item.Tickets * 100.0 / data.item.Quantity )" color="success"
              >progress</vs-progress
            >
          </div>
        </template>

        <template v-slot:cell(qty)="data">
          <div>{{ data.value | numFormat("0,0") }}</div>
        </template>
        <template v-slot:cell(remaining)="data">
          <div>{{ (data.item.Quantity - data.item.Tickets) | numFormat("0,0") }}</div>
        </template>

        <template v-slot:cell(Tickets)="data">
          <div>{{ data.value | numFormat("0,0") }}</div>
        </template>
        <!-- <template v-slot:cell(remaining)="data">
          <div>{{ data.value | numFormat("0,0") }}</div>
        </template> -->
        <!-- A custom formatted footer cell for field 'name' -->
        <template #foot()="data">
          <div style="font-weight:bolder; font-size:1.1rem;">
            <b>{{ data.field.foot }}</b>
          </div>
        </template>
      </b-table>
      <!--
      <data-table :columns="columns" :data="data" @onTablePropsChanged="reloadTable"></data-table>
      -->
      <div v-if="showPagination" class="mt-3 text-right">
        <vs-pagination
          :total="Math.ceil(totalRows / 30)"
          v-model="currentPage"
          prev-icon="arrow_back"
          next-icon="arrow_forward"
        ></vs-pagination>

        <div class="mt-3">{{ from }} to {{ to }} of {{ totalRows }} orders</div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import Service from "@/services";
import XLSX from "xlsx"; // import xlsx
export default {
  components: {},
  data: () => ({
    order_id: null,
    isBusy: false,
    showPagination: false,
    currentPage: 1,
    perPage: 1000,
    totalRows: 0,
    selected: [],
    search: "",
    filter: "",
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    columns: [
      { label: "ID", key: "product_id", sortable: true, foot: "" },
      { label: "Ticket", key: "pro_name", sortable: true, foot: "" },
      { label: "Quota", key: "Quantity", sortable: true, foot: "" },
      { label: "Issued", key: "Tickets", sortable: true, foot: "" },
      { label: "Waitlisted", key: "Waitlisted", sortable: true, foot: "" },
      { label: "Checked-in", key: "CheckedIn", sortable: true, foot: "" },
      { label: "Remaining", key: "remaining", sortable: true, foot: "" },
      { label: "Progress", key: "progress", sortable: true, foot: "" }
    ],
    items: []
  }),
  watch: {},
  created() {
    this.order_id = this.$route.query.o;
  },
  methods: {
    debounceInput: _.debounce(function(e) {
      this.filter = e;
      this.search = e;
    }, 500),
    dataProvider(ctx, callback) {
      setTimeout(() => {
        this.isBusy = true;
        let data = {
          e: this.$route.query.e
        };

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

        params =
          params +
          "&" +
          Object.keys(ctx)
            .map(key => key + "=" + ctx[key])
            .join("&");

        return Service.Report.ticket(params)
          .then(res => {
            this.data = res.data.map(item => {
              let qty = item.Quanity;

              let issue_percent = (item.Tickets / qty) * 100;
              if (issue_percent < 1) {
                issue_percent = Math.ceil(issue_percent);
              } else {
                issue_percent = Math.floor(issue_percent);
              }

              let progress = issue_percent;
              let remaining = qty - item.Tickets;
              if (qty == null) {
                remaining = "";
              }

              return {
                ...item,
                issue_percent: issue_percent,
                remaining: remaining,
                progress: progress,
                qty: qty
              };
            });

            let footerRow = res.data[res.data.length - 1];
            for (var key in footerRow) {
              if (footerRow.hasOwnProperty(key)) {
                let index = this.columns.findIndex(x => x.key == key);
                if (index >= 0) {
                  this.columns[index].foot = footerRow[key];
                }
              }
            }
            this.data.pop();
            callback(this.data);
          })
          .catch(error => {
            callback([]);
          });
      }, 500);
    },
    onExport() {
      let rows = [];
      let days = [];

      let header = this.columns.map((item, index) => {
        return { text: item.label };
      });

      rows = this.data.map(item => {
        return {
          ID: item.product_id,
          Ticket: item.pro_name,
          Quota: item.Quanity,
          Issued: item.Tickets,
          Waitlisted: item.Waitlisted,
          CheckedIn: item.CheckedIn,
          Remaining: item.Quanity - item.Tickets
        };
      });

      let dataExport = {};
      const dataWS = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "ticket_report.xlsx");
      this.$vs.loading.close();
    }
  }
};
</script>
